import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';


export const operatoreGuard: CanActivateFn = (route, state) => {

  const storageService = inject(StorageService);
  const router = inject(Router);

  const user = storageService.getUser();
  if (!user?.id) {
    router.navigate(["/backoffice"]);
    return false;
  }

  if (user?.tipo.toLocaleLowerCase() === 'operatore') {
    router.navigate(['/backoffice/home']);
    return false;
  }
  
  return true;
};
